export default __webpack_public_path__ + "static/media/iconChaise.9b96952e.svg";